export const SecondMs = 1000;
export const MinutesPerHour = 60;
export const SecondsPerMinute = 60;
export const MinuteMs = SecondsPerMinute * SecondMs;
export const HourMs = MinutesPerHour * MinuteMs;
export const DayMs = 24 * HourMs;
